<template>
  <responsive-modal v-model="visible" size="lg">
    <div class="tool-modal-digital-manager-guru p-5">
      <button class="btn text-secondary close" @click="visible = false">
        <i class="icon-x" />
      </button>
      <div>
        <strong>
          Integração Digital Manager Guru
        </strong>
      </div>
      <div class="d-flex align-items-center mb-5">
        <small class="text-dark flex-fill mt-5">
          <a
            target="_blank"
            href="https://digitalmanager.guru/"
            class="text-primary font-weight-bold text-decoration-none"
          >
            Conheça a Digital Manager Guru
          </a>
        </small>
      </div>
      <hr />
      <div class="row">
        <div class="col-lg-6">
          <form-group
            v-model="form.product_id"
            select
            id="product-select"
            label="Nome do produto"
            :disabled="isEdit"
            placeholder="Selecionar produto"
            :errors="errors.product_id"
            :options="products.map(({ id, name }) => ({ id, name }))"
          />
        </div>
        <div class="col-lg-6">
          <form-group
            v-model="form.description"
            id="description"
            label="Descrição da integração (Opcional)"
            placeholder="Digite a descrição da integração"
            :errors="errors.description"
          />
        </div>
        <div class="col-lg-6">
          <form-group
            v-model="form.internal_id"
            id="internal_id"
            label="ID externo"
            placeholder="Digite o ID do seu produto na Digital Manager Guru"
            :errors="errors.internal_id"
          />
        </div>
        <div class="col-lg-6">
          <form-group
            v-model="form.token"
            id="token"
            label="Token"
            placeholder="Digite o token da integração"
            :errors="errors.token"
          />
        </div>
        <div class="col-lg-6">
          <form-group
            label="Url externa"
            id="external_url"
            type="text"
            v-model="form.url"
            :errors="errors.url"
            placeholder="Digite a url"
          />
        </div>
      </div>
      <div class="d-flex justify-content-center pt-5">
        <button
          class="btn btn-primary"
          :disabled="!isValid"
          :class="{
            'bg-secondary border-secondary': !isValid
          }"
          @click="submit"
        >
          <loading :show="loading">
            Salvar
          </loading>
        </button>
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import { formFields } from "@/functions/helpers";
import { mapState } from "vuex";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields([
        "product_id",
        "url",
        "status",
        "description",
        "internal_id",
        "name"
      ]),
      loading: false,
      visible: false
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...this.form,
          ...v
        };
      }
    }
  },
  mounted() {
    this.loading = true;
    this.$store
      .dispatch("product/get", { limit: 500 })
      .then()
      .finally(() => {
        this.loading = false;
      });
  },
  computed: {
    ...mapState("product", ["products"]),
    isValid() {
      return (
        this.form.internal_id &&
        this.form.product_id &&
        this.form.url &&
        this.form.token
      );
    },
    isEdit() {
      return !!this.integrationToEdit?.id;
    }
  },
  methods: {
    clear() {
      this.form = { name: "digital-manager-guru" };
      this.$emit("clear-edit");
    },
    submit() {
      if (this.loading) return;

      this.loading = true;
      let data = { ...this.form };

      let action = "integration/postIntegration";
      if (this.integrationToEdit?.id) {
        data.id = this.integrationToEdit.id;
        action = "integration/putIntegration";
      }
      this.$store
        .dispatch(action, data)
        .then(() => {
          this.loading = false;
          this.visible = false;
          this.$emit("update-list");
          this.clear();
          this.$message.success("A integração foi salva!");
        })
        .catch(e =>
          this.handleErrors(
            e,
            "TRANSLATE_FIELD_INTEGRATION_MAP",
            "Erro ao salvar configuração"
          )
        )
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.tool-modal-digital-manager-guru {
  position: relative;
  .close {
    position: absolute;
    top: 0;
    right: 0;
  }

  button {
    i {
      font-size: 28px;
    }
  }
}
</style>
